import { useQuery } from '@tanstack/react-query';

import { NETWORK as BTC_NETWORK } from '@/networks/btc-like/btc';
import { NETWORK as DOGE_NETWORK } from '@/networks/btc-like/doge';
import { NETWORK as LTC_NETWORK } from '@/networks/btc-like/ltc';
import { BtcLikeCurrency } from '@/types';

const NETWORKS = {
  BTC: BTC_NETWORK,
  LTC: LTC_NETWORK,
  DOGE: DOGE_NETWORK,
};

export const useBtcLikeMempoolFees = (token: BtcLikeCurrency) => {
  const queryKey = ['BtcLikeMempoolFees', token];

  const queryFn = () => NETWORKS[token].api.getSatPerVbEstimateFee();

  return useQuery({
    queryKey,
    queryFn,
    initialData: null,
    refetchInterval: 15000,
  });
};
